var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "v-list-item",
        {
          attrs: { disabled: _vm.busy || !_vm.can_toggle },
          on: { click: _vm.toggle },
        },
        [
          _c(
            "v-list-item-icon",
            { staticClass: "mr-3" },
            [
              _c("v-icon", { attrs: { small: _vm.dense } }, [
                _vm._v("mdi-bell-ring-outline"),
              ]),
            ],
            1
          ),
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [_vm._v("Notificaciones push")]),
              _c("v-list-item-subtitle", { staticClass: "push-item__hint" }, [
                _vm._v(_vm._s(_vm.hint)),
              ]),
            ],
            1
          ),
          _vm.can_toggle
            ? _c(
                "v-list-item-action",
                { staticClass: "my-0" },
                [
                  _c("v-switch", {
                    staticClass: "mt-0 pt-0",
                    attrs: {
                      "input-value": _vm.enabled,
                      loading: _vm.busy,
                      readonly: "",
                      "hide-details": "",
                      dense: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }